<script setup lang="ts">
const { t } = useEkI18n();
</script>

<template>
  <IonItem
    lines="full"
    button
    @click="phoneApp.openAppSettings"
  >
    <IonLabel> 
      {{ t('settings.goToAppSettings') }}
       
      <p class="description">
        {{ t('settings.goToAppSettingsDescription') }}
      </p>
    </IonLabel>
    <IonIcon
      slot="end"
      class="fa-light fa-fw fa-arrow-up-right-from-square"
    />
  </IonItem>
</template>

  <style scoped>
  .description { 
    color: var(--ion-color-medium);
    padding: 0.5rem 0;
  }
  </style>

